/* import __COLOCATED_TEMPLATE__ from './status-403.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteErrorStatus403 extends Component {}
